import React from 'react';
import {connect} from 'react-redux';
import OpenExplore, {DisplayMode} from '../../../components/openexplore/OpenExplore/OpenExplore';
import {setOxMode, setOxListMode} from "../../../store/ui/actions";

export class OpenExploreListPage extends React.Component {

    componentWillMount() {
        this.props.setOxMode(DisplayMode.MODE_LIST);
    }

    render() {
        return <OpenExplore
            mode={DisplayMode.MODE_LIST}
            match={this.props.match}
            setOxListMode={this.props.setOxListMode}
            listMode={this.props.listMode}
        />
    }
}

function mapStateToProps(state, ownProps) {
    return {
        listMode: state.ui.oxListMode
    }
}

export default connect(mapStateToProps, {
    setOxMode, setOxListMode
})(OpenExploreListPage);



// WEBPACK FOOTER //
// src/containers/openexplore/OpenExploreListPage/OpenExploreListPage.js